import state from './User/states'
import mutations from './User/mutations'
import actions from './User/actions'
import getters from './User/getters'

// 共通
const Store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default Store
